var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import Upload from "rc-upload";
import { observer } from "mobx-react-lite";
import { useFormContext } from "./Form";
import { classNames } from "./utils/classNames";
import { useTranslation } from "./hooks/useTranslation";
import { withFormWrapper } from "./withFormWrapper";
import { createUseStyles } from "react-jss";
var styles = {
    root: {
        border: {
            width: 1,
            style: "dashed",
            color: "#D5DFE7",
        },
        backgroundColor: "#F3F9FC",
        width: "100%",
        display: "flex",
        borderRadius: 4,
        padding: 16,
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "inset 0 1px 1px rgb(0 0 0 / 5%)",
        minHeight: 208,
        marginBottom: 10.5,
        "&:focus": {
            outline: "-webkit-focus-ring-color auto 0px;",
            "& .btn-primary": {
                outline: "-webkit-focus-ring-color auto 1px;",
            },
        },
    },
    message: {
        display: "block",
        marginBottom: 8,
        textAlign: "center",
    },
    icon: {
        display: "block",
        textAlign: "center",
        fontSize: 60,
        color: "#D5DFE7",
        marginBottom: 8,
    },
    buttonWrapper: {
        display: "flex",
        justifyContent: "center",
    },
    button: {
        textAlign: "center",
    },
};
var useStyles = createUseStyles(styles);
var UNITS = ["bytes", "kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
export var RawUploadInput = observer(function (_a) {
    var acceptedFileTypes = _a.acceptedFileTypes, onChange = _a.onChange, name = _a.name, dropMessage = _a.dropMessage, onStart = _a.onStart, beforeUpload = _a.beforeUpload, onError = _a.onError, onSuccess = _a.onSuccess, action = _a.action, _b = _a.runBeforeHandlersOnly, runBeforeHandlersOnly = _b === void 0 ? false : _b;
    var t = useTranslation();
    dropMessage = dropMessage || t("Drop Files Here (max file size: 4GB)");
    var classes = useStyles();
    var _c = useState(), file = _c[0], setFile = _c[1];
    var values = useFormContext().values;
    var handleBeforeUpload = function (file, fileList) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            beforeUpload && beforeUpload(file, fileList);
            onChange && onChange(file, values.get(name));
            setFile(file);
            values.set(name, file);
            return [2 /*return*/, !runBeforeHandlersOnly];
        });
    }); };
    var formatBytes = function (bytes) {
        var l = 0, n = bytes || 0;
        while (n >= 1024 && ++l) {
            n = n / 1024;
        }
        return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + UNITS[l];
    };
    return (React.createElement(Upload, { action: action, type: "drag", accept: acceptedFileTypes, beforeUpload: handleBeforeUpload, className: classes.root, onStart: onStart, onError: onError, onSuccess: onSuccess },
        React.createElement("span", null,
            React.createElement("span", { className: classNames(classes.icon, "glyphicon-pro", "glyphicon-pro-open") }),
            React.createElement("span", { className: classes.message }, (file === null || file === void 0 ? void 0 : file.name)
                ? "".concat(file === null || file === void 0 ? void 0 : file.name, " (").concat(formatBytes(file.size), ")")
                : dropMessage),
            React.createElement("span", { className: classes.buttonWrapper },
                React.createElement("span", { className: classNames(classes.button, "btn-primary", "btn") }, t("Browse..."))))));
});
export var UploadInput = withFormWrapper({
    WrappedComponent: RawUploadInput,
    options: "validationOnly",
});
